<template>
    <v-card flat>
        <v-card-title>
            <Button
                    width="248"
                    depressed
                    v-on:onClick="openCreateAllowedVendor"
                    class="my-3"
                    content="+ ADD VENDOR"
            />
            <v-spacer></v-spacer>
            <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
            ></v-text-field>
        </v-card-title>
        <v-data-table
                class="custom-table custom-table__header"
                :headers="headers"
                :items="allowedVendorsByClientData"
                :loading="loading"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                @update:sort-desc="handleSortDesc"
                @update:sort-by="handleSortBy"
                hide-default-footer
        >
            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        @click="openDeleteItem(item)"
                        title="Delete ALLOWED VENDOR"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data> NO DATA </template>
        </v-data-table>
        <v-row class="align-center" v-if="allowedVendorsByClientData.length">
            <v-col cols="12" sm="11" >
                <v-pagination
                        v-model="page"
                        :length="pageCount"
                        :total-visible="7"
                        @input="onChangePagination"
                ></v-pagination>
            </v-col>
            <v-col cols="12" sm="1">
                <v-select
                        :value="10"
                        :items="[5, 10, 15, 'All']"
                        label="Items per page"
                        @change="handleItemsPerPage"
                        hint="Items per page"
                        persistent-hint
                ></v-select>
            </v-col>
        </v-row>
        <v-dialog v-model="dialogCreate" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="create"
                        v-model="valid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">{{ formTitle }}</v-card-title>
                    <v-card-text>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" class="py-0">
                                    <v-autocomplete
                                            v-model="newClientCustomAllowedVendor.vendor_id"
                                            :items="getVendorsExceptBindedByClient"
                                            placeholder="Search vendor by name"
                                            item-value="id"
                                            item-text="name"
                                            required
                                            dense
                                            :rules="[autocompleteRule]"
                                            :loading="loadingVendors"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-container class="py-0">
                            <v-row>
                                <v-col cols="12" align="right">
                                    <v-btn color="red darken-1" text @click="closeCreate">Cancel</v-btn>
                                    <v-btn color="green darken-1" text @click="save">Save</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px" persistent>
            <v-card>
                <v-form
                        ref="delete"
                        v-model="deleteValid"
                        lazy-validation
                >
                    <v-card-title class="headline scan-header">Confirm delete ALLOWED VENDOR</v-card-title>
                    <v-card-text>
                        <div>Please, enter 'Delete {{allowedVendorName}}' in the text field to confirm ALLOWED VENDOR deletion</div>
                        <v-text-field
                                v-model="confirmDelete"
                                label="Delete ALLOWED VENDOR"
                                :rules="[deleteRule]"
                                single-line
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteClientCustomAllowedVendor">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
    import Button from "../../common/Button";
    import { createNamespacedHelpers } from "vuex";
    const authHelper = createNamespacedHelpers("auth");
    const adminDashboardHelper = createNamespacedHelpers("adminDashboard");
    import adminDashboardApi from '../../../api/adminDashboard'
    export default {
        components: {Button},
        name: 'AllowedVendorsByClient',
        computed:{
            ...authHelper.mapGetters(["getSelectedClient"]),
            ...adminDashboardHelper.mapGetters(["getAllowedVendorsByClient", "getVendorsExceptBindedByClient"]),
            formTitle () {
                return this.editedIndex === -1 ? 'CREATE ALLOWED VENDOR' : 'EDIT ALLOWED VENDOR'
            },
        },
        data () {
            return {
                search: '',
                headers: [
                    { text: 'Name', align: 'start', value: 'name' },
                    { text: 'Sourcepoint ID', value: 'sp_id', sortable: false },
                    { text: 'IAB ID', value: 'iab_vendor', sortable: false },
                    { text: 'Actions', value: 'actions', sortable: false }
                ],
                allowedVendorsByClientData: [],
                dialogCreate: false,
                dialogDelete: false,
                loading: true,
                loadingVendors: true,
                page: 1,
                pageCount: 1,
                itemsPerPage: 10,
                totalCount: 1,
                sortDesc: true,
                sort_field: "name",
                newClientCustomAllowedVendor: {
                    vendor_id: '',
                    client_id: '',
                },
                allowedVendorId: '',
                allowedVendorName: '',
                editedIndex: -1,
                autocompleteRule: v =>{
                    if (v && Object.keys(v).length !== 0) return true;
                    return 'This field is required';
                },
                deleteRule: v =>{
                    if (!(v && Object.keys(v).length !== 0)) {
                        return 'This field is required';
                    } else if(!(v && this.confirmDelete.includes(`Delete ${this.allowedVendorName}`))){
                        return 'The confirmation message must meet the requirements';
                    } return true;
                },
                confirmDelete: '',
                valid: true,
                deleteValid: true,
            }
        },
        methods: {
            ...adminDashboardHelper.mapActions([ "fetchAllowedVendorsByClient", "fetchVendorsExceptBindedByClientId"]),
            async getVendorsExceptBindedByClientData(){
                this.loadingVendors = true;
                //TODO search on server side
                await this.fetchVendorsExceptBindedByClientId({client_id: this.getSelectedClient, search: ''});
                this.loadingVendors = false;
            },
            async getAllowedVendorsByClientDashboard(){
                this.loading = true;
                await this.fetchAllowedVendorsByClient({
                    client_id: this.getSelectedClient,
                    page: this.page,
                    page_size: this.itemsPerPage < 0 ? this.pageCount : this.itemsPerPage,
                    sort: this.sortDesc ? "asc" : "desc",
                    s: this.search,
                    sort_field: this.sort_field ? 'vendor.' + this.sort_field : 'vendor.name'
                });
                this.loading = false;
            },
            openCreateAllowedVendor(){
                this.getVendorsExceptBindedByClientData();
                this.dialogCreate = true;
            },
            closeCreate () {
                this.dialogCreate = false;
                this.newClientCustomAllowedVendor = {
                    vendor_id: '',
                    client_id: this.getSelectedClient,
                };
                this.$refs.create.resetValidation();
            },
            async save(){
                if(this.$refs.create.validate()){
                    try{
                        await adminDashboardApi.createClientCustomAllowedVendor(this.newClientCustomAllowedVendor);
                        this.closeCreate();
                        this.getAllowedVendorsByClientDashboard();
                    }catch(err){
                        alert(err.response ? err.response.data : err)
                    }
                }
            },
            openDeleteItem(allowedVendor){
                this.allowedVendorId = allowedVendor.id;
                this.allowedVendorName = allowedVendor.name;
                this.dialogDelete = true
            },
            closeDelete(){
                this.dialogDelete = false;
                this.confirmDelete = '';
                this.$refs.delete.resetValidation();
            },
            async deleteClientCustomAllowedVendor(){
                if(this.$refs.delete.validate()){
                    if(this.confirmDelete.includes(`Delete ${this.allowedVendorName}`)){
                        try{
                            await adminDashboardApi.deleteClientCustomAllowedVendor({vendor_id: this.allowedVendorId, client_id: this.getSelectedClient});
                            this.closeDelete();
                            this.getAllowedVendorsByClientDashboard();
                        }catch(err){
                            alert(err)
                        }
                    }
                }
            },
            handleItemsPerPage(itemsPerPage){
                this.page = 1;
                if(itemsPerPage === 'All'){
                    this.itemsPerPage = this.totalCount;
                } else {
                    this.itemsPerPage = itemsPerPage;
                }
                this.getAllowedVendorsByClientDashboard();
            },
            handleSortDesc(desc){
                if( this.sortDesc !== desc[0] && desc.length){
                    this.sortDesc = desc[0];
                    this.getAllowedVendorsByClientDashboard();
                }
            },
            handleSortBy(sortBy){
                if(this.sort_field !== sortBy[0] && sortBy.length){
                    this.sort_field = sortBy[0];
                    this.getAllowedVendorsByClientDashboard();
                }
            },
            onChangePagination(){
                this.getAllowedVendorsByClientDashboard();
            },
        },
        created () {
            this.newClientCustomAllowedVendor.client_id = this.getSelectedClient;
            this.getAllowedVendorsByClientDashboard();
        },
        watch: {
            getAllowedVendorsByClient: function(e){
                this.allowedVendorsByClientData = e.results;
                this.pageCount = Math.ceil(e.count/this.itemsPerPage);
                this.totalCount = e.count;
            },
            search: function(){
                this.page = 1;
                this.getAllowedVendorsByClientDashboard();
            },
            getSelectedClient: function() {
                this.newClientCustomAllowedVendor.client_id = this.getSelectedClient;
                this.getAllowedVendorsByClientDashboard();
            },
        }
    }
</script>
